import React, { Component } from 'react';
import './form-result.css';
import  { connect } from 'react-redux';
import FormResult from './FormResult';
import { BUILDER_TYPES } from '../../config/constants';
import { ResultPageWrapper } from '../resultPageWrapper';


class SuccessPageResult extends Component {


    render() {
        const { typeIds, bgImage, colors } = this.props;
        return (
            <>
                {
                    typeIds[BUILDER_TYPES.SUCCESS_PAGE].length ?

                    <FormResult
                        targetBuilderType={BUILDER_TYPES.SUCCESS_PAGE}
                        backgroundImage={bgImage}
                        isSuccessPage={true}
                    />

                    :

                    <>
                        <ResultPageWrapper
                            backgroundImage={bgImage}
                            targetBuilderType={BUILDER_TYPES.SUCCESS_PAGE}
                            colors={colors}
                            isFullScreen={true}
                        >
                            <div className="form-container default-success-page_text">
                                <h1 className="default-success-content-text">Success!</h1>
                                <h3 className="default-success-content-text">You have successfully completed this Form!</h3>

                                <h5 className="default-success-bottom-text">Thank you,</h5>
                                <h5 className="default-success-bottom-text">The Duuzra Team</h5>
                            </div>
                        </ResultPageWrapper>
                    </>
                }
            </>
        );
    }
}

export default connect(
    state => ({
        bgImage: state.bgImage,
        colors: state.colors,
        typeIds: state.typeId,
    }),
    {}
  )(SuccessPageResult);
